import React from "react";
import GetCountries from "./functions/GetCountries";
import GetVendors from "./functions/GetVendors";
import Unpacking from "./unpacking";
import Reception from "./reception";
import GetRepairTypes from "./functions/GetRepairTypes";
import GetProcessingPriority from "./functions/GetProcessingPriority";
import GetDeviceState from "./functions/GetDeviceState";

class ReceptionUnpacking extends React.Component {
  state = {
    loading: false,
    countriesData: [],
    vendors: [],
    processingPriority: [],
    repairType: [],
    deviceState: [],
    commChanel: [
      { value: 1, label: "E-mail" },
      { value: 3, label: "Mobil" },
    ],
    RFID: {
      open: false,
      data: null,
    },
    prepare: localStorage.getItem("type_reception")
      ? localStorage.getItem("type_reception")
      : false,
  };

  GetMainData = async () => {
    this.setState({ loading: true });
    this.setState({
      countriesData: await GetCountries({ ...this.props }),
      vendors: await GetVendors({ ...this.props, vendType: "ALL" }),
      repairType: await GetRepairTypes({ ...this.props }),
      processingPriority: await GetProcessingPriority({ ...this.props }),
      deviceState: await GetDeviceState({ ...this.props }),
      RFID: {
        ...this.state.RFID,
        open: sessionStorage.getItem("RFID") ? false : true,
        data: sessionStorage.getItem("RFID")
          ? sessionStorage.getItem("RFID")
          : null,
      },
      loading: false,
    });
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <this.props.Icon fainbox className="c-placeholder c-green" />,
      Title: "Příjem a rozbalení zásilek",
      SubTitle: "Začni tím, že si vybereš příjem nebo předpříjem",
    });
    this.GetMainData();
    this.setState({ prepare: true });
    localStorage.setItem("type_reception", true);
  }

  render() {
    const { Bs, VARIANT, SIZE, Icon } = this.props;
    return (
      <>
        {this.state.RFID.open && (
          <Bs
            modal
            show={this.state.RFID.open}
            keyboard={false}
            backdrop="static"
            centered
            size={SIZE.SMALL}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader>
              <Bs row>
                <Bs col xs={12}>
                  <Bs span>Přihlaš se pomocí RFID </Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs small className="text-muted">
                    Toto je pouze provizorní záležitost. Po nastavení účtů a
                    dalších záležitostí se toto dialogové okno nebude
                    zobrazovat.
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
            <Bs modalbody>
              <Bs row>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    autofocus
                    value={this.state.RFID.data}
                    onChange={(e) => {
                      sessionStorage.setItem("RFID", e.target.value);
                      this.setState({
                        RFID: {
                          ...this.state.RFID,
                          data: e.target.value,
                        },
                      });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.setState({
                          RFID: { ...this.state.RFID, open: false },
                        });
                      }
                    }}
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs modalfooter>
              <Bs row>
                <Bs col xs={12} className="d-flex justify-content-end">
                  <Bs
                    button
                    variant={VARIANT.SUCCESS}
                    size={SIZE.SN}
                    onClick={() =>
                      this.setState({
                        RFID: { ...this.state.RFID, open: false },
                      })
                    }
                  >
                    Autorizovat se
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        )}
        <Bs row className="mb-2">
          <Bs col xs={6} className="d-flex justify-content-start">
            <Bs
              button
              disabled={this.state.loading}
              size={SIZE.SM}
              variant={VARIANT.TRANSPARENT}
              onClick={this.GetMainData}
            >
              {this.state.loading ? (
                <>
                  Načítálm číselníky... <Bs brtxspin />
                </>
              ) : (
                "Znovu načíst číselníky"
              )}
            </Bs>
          </Bs>
          <Bs col xs={6} className="d-flex justify-content-end">
            <Bs formtext className="me-4">
              {this.state.prepare
                ? "Přepnout na příjem"
                : "Přepnout na předpříjem"}
            </Bs>
            <Bs
              formswitch
              disabled={this.state.loading}
              checked={this.state.prepare}
              onChange={(e) => {
                this.setState({ prepare: e.target.checked });
                localStorage.setItem("type_reception", e.target.checked);
              }}
            />
          </Bs>
        </Bs>
        <Bs row>
          <Bs col xs={12}>
            {this.state.prepare && !this.state.RFID.open && (
              <Unpacking {...this.props} {...this.state} />
            )}
            {!this.state.prepare && 1 === 0 && (
              <Reception {...this.props} {...this.state} />
            )}
          </Bs>
        </Bs>
      </>
    );
  }
}

export default ReceptionUnpacking;
